// src/components/store/sections/hero-banner/HeroV38DiagonalarenaTealLagoon.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV38DiagonalarenaTealLagoon(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={38}
      archKey="diagonal_arena"
      archLabel="Diagonal Split Arena"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      {...props}
    />
  );
}
